var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn",class:_vm.classic,on:{"click":function (e){ return this$1.$emit('click',e); }}},[(_vm.iconSide==='left')?_c('i',{class:_vm.icon}):_vm._e(),_c('span',{domProps:{"textContent":_vm._s(_vm.text)}}),(_vm.iconSide==='right')?_c('i',{class:_vm.icon}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }